function ErrorClientList({ errors }: { errors: string[] }) {
  if (errors.length === 0) return null;

  return (
    <div
      className="my-1 flex max-w-full flex-col gap-2 rounded-md bg-red-200 px-4 py-3 text-sm text-red-700"
      role="alert"
    >
      <ul className="list-inside list-decimal space-y-1 break-words">
        {errors.map((error, i) => (
          <li key={i} className="max-w-full leading-snug">
            {error}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ErrorClientList;
